import React from 'react'
import styled from 'styled-components'

import StandardLayout from 'components/layouts/Standard'

const EmptyMessage = styled.div`
  color: black;
  font-size: 1.5rem;
  opacity: 0.1;
`

export default () => (
  <StandardLayout>
    <div
      style={{
        width: '100%',
        height: '30vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <EmptyMessage>Coming Soon</EmptyMessage>
    </div>
  </StandardLayout>
)
